import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { KINDS } from '../../lib/u99';
import ShareBar from './ShareBar';

export const Byline = ({ author = 'Kyle Hinton' }) => (
  <p className="mt-6 font-celestial text-lg sm:text-xl text-slate-300" data-testid="publication-byline">
    <span className="text-slate-500 italic">by</span> <span className="text-amber-100 tracking-wide">{author}</span>
  </p>
);

export const KindEyebrow = ({ kind, number, label }) => (
  <span className="font-mono-precision text-xs uppercase tracking-[0.3em] text-amber-300" data-testid="publication-kind">
    {number != null ? `${KINDS[kind]?.article || 'A'} ${KINDS[kind]?.name || kind} · No. ${String(number).padStart(2, '0')}` : `${KINDS[kind]?.article || 'A'} ${KINDS[kind]?.name || kind}`}
  </span>
);

export default function Colophon({ kind, title, author = 'Kyle Hinton', date, words, verified, path, backTo, backLabel }) {
  const url = `${window.location.origin}${path}`;
  const year = new Date(date).getFullYear();
  return (
    <aside className="mt-24 rounded-3xl border border-white/[0.08] bg-[#04070f] p-7 lg:p-10" data-testid="publication-colophon">
      <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500">Standalone publication</p>
      <p className="mt-4 font-celestial text-2xl text-slate-100 leading-snug">{title}</p>
      <p className="mt-1 font-celestial text-base text-amber-100/90">{author}</p>
      <div className="mt-6 grid sm:grid-cols-2 gap-x-10 gap-y-3 font-mono-precision text-[10px] uppercase tracking-[0.2em] text-slate-500">
        <span>{KINDS[kind]?.name || kind} · {year}</span>
        <span>{words?.toLocaleString()} words</span>
        <span>United 99 Unleashed · cosmosres.com</span>
        <span>Published {new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-3">
        {verified ? (
          <span className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.2em] text-emerald-400 border border-emerald-400/30 rounded-full px-3 py-1" data-testid="verbatim-badge"><ShieldCheck size={12} /> Verbatim · matches source word for word</span>
        ) : (
          <span className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.2em] text-slate-500 border border-white/10 rounded-full px-3 py-1" data-testid="verbatim-pending">Text as supplied by the author</span>
        )}
      </div>
      <div className="mt-5"><ShareBar title={title} author={author} path={path} /></div>
      <p className="mt-8 pt-6 border-t border-white/[0.06] font-celestial text-sm sm:text-base tracking-wide text-amber-100/90" data-testid="publication-copyright">© {author}, {year}. All rights reserved.</p>
      <p className="mt-4 text-xs text-slate-500 leading-relaxed">Cite as: {author}. <em>{title}</em>. United 99 Unleashed, {year}. {url}</p>
      {backTo && <Link to={backTo} className="mt-6 inline-block font-mono-precision text-[10px] uppercase tracking-[0.25em] text-slate-500 hover:text-amber-300" data-testid="colophon-back-link">← {backLabel}</Link>}
    </aside>
  );
}
